import get from "lodash/get";
import { useAppContext } from "../context";
import { arrInvalid } from "../helper";

const PRIVILEGES = {
    Create: "create_user",
    Edit: "edit_user",
    ActiveOrDeactive: "active_deactive_user",
    Set: "set_user_privilege",
};

const usePrivileges = (currentUserProp) => {
    // const { currentUser } = currentUserProp
    //     ? { currentUser: currentUserProp }
    //     : useAppContext();
    const isRootUser = get(currentUserProp, "isRootUser") || false;
    const privileges = get(currentUserProp, "privileges") || [];

    const fn = (type) => {
        if (isRootUser) return true;
        if (arrInvalid(privileges)) return false;

        return privileges.includes(type);

        // const val = isRootUser
        //     ? true
        //         ? arrInvalid(privileges)
        //         : false
        //     : privileges.includes(type);

        // console.log("val", val);
        // return val;
    };

    return {
        canCreate: fn(PRIVILEGES.Create),
        canEdit: fn(PRIVILEGES.Edit),
        canActiveOrDeactive: fn(PRIVILEGES.ActiveOrDeactive),
        canSetPrivileges: fn(PRIVILEGES.Set),
    };
};

export { usePrivileges };
